module.exports = __webpack_public_path__ + "img/ManMudra-Logo.9db68f04.svg";